import { getQuickSubmitCandidates } from '../../../../services/candidatesApi';
import { getJobList } from '../../../../services/dropdownApi';
import { checkSubmissionExists } from '../../../../services/popupApi';

export const api = {
  searchOptions: async (field, search, context) => {
    if (field.searchFetchKey === 'quickSubmitJobList') {
      const record = context.selectedRecords?.[0] ?? {};
      const candidateId = record.id ?? record._id ?? context.selectedIds?.[0];
      const response = await getJobList({ searchQuery: search, candidateId });
      const list = Array.isArray(response?.data) ? response.data : [];
      return list.map((item) => ({
        label: [item.jobReferenceId, item.jobTitle].filter(Boolean).join(' - ') || String(item._id ?? ''),
        value: item._id ?? '',
      }));
    }
    if (field.searchFetchKey === 'quickSubmitCandidates') {
      const record = context.selectedRecords?.[0] ?? {};
      const jobId =
        context.jobId ?? record.jobId ?? record.id ?? record._id ?? context.selectedIds?.[0];
      return getQuickSubmitCandidates({
        isFromSubmission: context.isFromSubmission,
        jobId,
        submissionId: context.submissionId,
        search,
      });
    }
    return [];
  },
  submit: async (values, context) => {
    const { navigate, selectedRecords = [], selectedIds = [], moduleName, isFromSubmission = false } = context;
    const record = selectedRecords[0] ?? {};

    // Resolve the job + candidate the same way for every entry point.
    let jobId;
    let candidateId;
    if (context.jobId) {
      // Job already known (see getFields) — the selected row is the candidate.
      jobId = context.jobId;
      candidateId = record.id ?? record._id ?? selectedIds[0] ?? '';
    } else if (moduleName === 'candidate') {
      jobId = values.jobId ?? '';
      candidateId = record.id ?? record._id ?? selectedIds[0] ?? '';
    } else {
      jobId = record.jobId ?? record.id ?? record._id ?? selectedIds[0] ?? '';
      candidateId = values.candidate ?? '';
    }

    const params = new URLSearchParams();
    if (candidateId) params.set('candidateId', candidateId);
    params.set('isFromSubmission', String(!!isFromSubmission));

    if (isFromSubmission) {
      // Working FROM an existing submission (resubmit): carry its id so the
      // create form prefills from the SUBMISSION record (not the candidate) and
      // the submission id is visible in the navigation.
      const submissionId = context.submissionId ?? record.submissionId ?? record._id ?? record.id ?? selectedIds[0] ?? '';
      if (submissionId) params.set('submissionId', submissionId);
    } else if (jobId && candidateId) {
      // Fresh quick submit: block if this candidate already has a submission for
      // this job so we never start a duplicate. The form otherwise prefills from
      // the CANDIDATE module (isFromSubmission=false).
      const { exists, submissionId } = await checkSubmissionExists({ jobId, applicantId: candidateId });
      if (exists) {
        throw new Error(
          `This candidate is already submitted for this job${submissionId ? ` (submission ${submissionId})` : ''}.`,
        );
      }
    }

    navigate(`/submission-create/${jobId}?${params.toString()}`);
    return { navigated: true };
  },
};
